import { useState } from 'react';

interface UseGrowthbookFeatureFlagArgs<T> {
    featureFlag: string;
    defaultValue: T;
}

// GrowthBook (and its `@deriv-com/analytics` host) was removed in PR-A.4.
// This hook is now a stub that always returns the caller's default.
// Re-introducing flag delivery is its own design exercise — feature-flag
// callers should migrate off this hook over time.
const useGrowthbookFeatureFlag = <T extends string | boolean>({
    defaultValue,
}: UseGrowthbookFeatureFlagArgs<T>) => {
    const [featureFlagValue] = useState<T>(defaultValue);
    return featureFlagValue;
};

export default useGrowthbookFeatureFlag;
